var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management", {
    attrs: {
      headings: _vm.headings,
      entries: _vm.entries,
      loading: _vm.loading,
      sort: _vm.sort,
      "sort-dir": _vm.sortDir,
    },
    on: {
      showModal: (id) => {
        _vm.selectedEntryId = id
        _vm.showModal()
      },
      updateSort: (key) => {
        _vm.updateSort(key)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "heading",
        fn: function () {
          return [_vm._v("Category Management")]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return _vm._l(_vm.sortedEntries, function (category) {
            return _c("category-management-list-item", {
              key: category.id,
              attrs: { category: category },
              on: {
                edit: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showModal()
                },
              },
            })
          })
        },
        proxy: true,
      },
      {
        key: "modal",
        fn: function () {
          return [
            _c("category-management-modal", {
              ref: "modal",
              attrs: {
                category:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
              },
              on: {
                create: (category) => {
                  _vm.add(category)
                },
                update: (category) => {
                  _vm.update(category)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }